export default "__VITE_ASSET__d2756fa4__"